import './Expressions.scss';
import colors from '../../../assets/scss/variable/color.scss';
import React, { useState, useEffect } from "react";
import T from "../../../shared/component/t/T";
import Storage from "../../../helpers/Storage";
import snippets from "../../../helpers/snippets";
import Modal from "../../../shared/component/Modal/Modal";
import TextBox from "../../../shared/component/textbox/Textbox";
import { default as _ } from '../../../helpers/Translate';
import { useDispatch } from 'react-redux';
import {_loading} from "../../../actions/Loading";
import eventBus from "../../../core/utils/EventBus";
import BaseApi from "../../../core/api/BaseApi";

const baseApi = new BaseApi()

export default function Expressions(props) {
    const dispatch = useDispatch();
    const language = useState(Storage.getLanguage())
    const [modalShow, setModalShow] = useState(false);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [study, setStudy] = useState(props.study)

    const [expressions, setExpressions] = useState([]);
    const [expression, setExpression] = useState();
    const [shortcut, setShortcut] = useState();
    const [mode, setMode] = useState(`create`)
    const [expId, setExpId] = useState("")
    const [expModality, setExpModality] = useState("")

    useEffect(() => {
        setExpressions(props.getOnlineExpressions())
    },[props.getOnlineExpressions()]);

    const onClose = () => {
        props.onClose();
    }

    const refreshExpressions = ()=>{
        eventBus.dispatchEvent("refreshExpressions");
        setExpressions(props.getOnlineExpressions())
    }

    function sendNewExpressionToServer() {
        dispatch(_loading(true));
        let obj = {}
        obj = mode==="edit" ? { ...obj, "id": expId } : {...obj}
        obj = { ...obj, "expression": expression }
        obj = { ...obj, "shortcut": shortcut }
        obj ={ ...obj, "modality_id": expModality }

        baseApi.fullFetch("expressions", mode, {data:obj, showMessageSuccess:true, version:2})
        .then(() => {
            refreshExpressions()
            setModalShow(false)
        })
    }

    const deleteExpressionConfirmation=(item)=>{
        setModalShowDelete(true)
        setExpId(item.id)
    }

    const deleteExpression=()=>{
        baseApi.fullFetch("expressions", "delete", { data:{id:expId}, showMessageSuccess:true, version:2})
        .then(() => {
            refreshExpressions()
        }).finally(()=>{
            setModalShowDelete(false)
        })
    }

    const expressionEdit=(event, item)=> {
        setMode("edit")
        setExpression(item.expression)
        setShortcut(item.shortcut)
        setExpId(item.id)
        setExpModality(item.modality_id)
        setModalShow(true)
    }

    const expressionCreate=()=> {
        setMode("create")
        setExpression("")
        setShortcut("")
        setExpModality(study.main_modality_id)
        setModalShow(true)
    }

    return (
        <>
            <div className="expressions">
                    <div className={'__header'}>
                        <div className={'__title'}>
                            <T token={'expressions'} />
                            <i className={"fal fa-info-circle"}
                               title={_.init("shortcut_explanation", language)}
                            />
                        </div>
                        <div className={'__close'}
                             onClick={() => onClose('modalShowExpressions')}
                        >
                            <i className="fal fa-times-circle" />
                        </div>

                        <div className={'__addNewExpression'}
                             onClick={() => expressionCreate()}
                        >
                            <i className="fal fa-plus-circle" />
                            {/*<T token={'ٔcreate_expression'} />*/}
                        </div>
                    </div>
                    <div className='__body'>
                        <div className={'section__title'}>

                        </div>
                        {snippets.isObjectEmpty(expressions)  ?
                            <div className={"NoExpression"}>
                                <T token={"no_expression"}/>
                            </div>
                            :
                            <div className={'expressions__section__content__lists'}>
                                <div className={""}>
                                    {Object.keys(expressions).map((keys, index)=>
                                        <div className='expressions__lists__item'
                                             key={index}
                                             title={expressions[keys].expression}
                                             // onClick={(event) => templateClick(item.id, event)}
                                        >
                                            <div className={'expressions__lists__item__top'}>
                                                <div className='__title'>
                                                    {expressions[keys].expression}
                                                </div>
                                                <div className={"edit__delete"}>
                                                    <i className={'fa fa-light fa-pen-to-square'}
                                                       onClick={(event)=>expressionEdit(event,expressions[keys])}
                                                    />
                                                    <i className={'fa  fa-light fa-trash-can'} style={{color: colors.redLight}}
                                                       // onClick={()=>deleteExpression(}
                                                       onClick={()=>deleteExpressionConfirmation(expressions[keys])}
                                                    />
                                                </div>
                                            </div>

                                            <div className='__contents'>
                                                <div className={"shortcut__Hotkey"}>
                                                    <div className={'hotkeys'}>
                                                        ({_.init ("ctrl_enter", 'en')})
                                                    </div>
                                                    <div className='shortcut'>
                                                        {expressions[keys].shortcut}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                    </div>
                </div>

            <Modal className="ModalExpressionNewOne"
                show={modalShow}
                title={mode === 'edit'? "modify_expression":'save_new_expression'}
                closeModal={() => setModalShow(false)}
                closeable={false}
            >
                <div className="">
                    <hr />

                    <div className={'imodal__body'}>
                        <div className={'pattern__section pattern__section--header'} >
                            <div className={'section__title'}>
                                <T token={"new_expression_text"} />
                                <TextBox className={{}}
                                    changeValue={e => setExpression(e.target.value)}
                                    name="new_expression_text"
                                    value={expression}
                                    placeholder={_.init(`description_name`)}
                                />
                            </div>

                            <div className={'section__content'}>
                                <div>
                                    <T token={"shortcut"} />
                                    <div className={"shortcutWithCtrlEnter"}>
                                        <TextBox className={{}}
                                            changeValue={e => setShortcut(e.target.value)}
                                            name="new_expression_text"
                                            value={shortcut}
                                            placeholder={_.init("shortcut_placeholder")}
                                        />
                                        <div className={"ctrlEnter"}>
                                            <T token={"ctrl_enter"} />
                                        </div>

                                    </div>

                                    <div className="__Description">
                                        <T token={"shortcut_explanation"} />
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                    <div className={'imodal__action'}>
                        {mode === 'create'?
                            <div className={'imodal__btn imodal__btn--primary'}
                                onClick={()=>sendNewExpressionToServer("create")}
                            > <T token={'save_expression'} />
                            </div>
                            :
                            <div className={'imodal__btn imodal__btn--primary'}
                                 onClick={()=>sendNewExpressionToServer('edit')}
                            > <T token={"edit"} />
                            </div>
                        }
                        <div className={'imodal__btn imodal__btn--secondary'}
                            onClick={()=>setModalShow(false)}
                        ><T token={'cancel'} /></div>
                    </div>
                </div>
            </Modal>

            <Modal className="ModalExpressionDelete"
                   show={modalShowDelete}
                   title='expression_delete_confirmation'
                   closeModal={() => setModalShowDelete(false)}
                   closeable={true}
            >
                <div className="">
                    <div className={'imodal__action'}>
                        <div className={'imodal__btn imodal__btn--primary'}
                             onClick={()=>deleteExpression()}
                        > <T token={'expression_delete'} />
                        </div>

                        <div className={'imodal__btn imodal__btn--secondary'}
                             onClick={()=>setModalShowDelete(false)}
                        ><T token={'cancel'} /></div>
                    </div>
                </div>
            </Modal>
        </>
    )
};
